import WideSecureLayout from "../../../../layout/WideSecureLayout.jsx";
import React from "react";
import DashboardGrid from "../../../../components/dashboard/DashboardGrid.jsx";
import OrderDashboardFilters from "./OrderDashboardFilters.jsx";

export default function OrderDashboardLayout({title, children, hideFilters, showMarketingFilters}) {
    // noinspection JSValidateTypes
    return <WideSecureLayout title={title} actions={
        <OrderDashboardFilters
            hideFilters={hideFilters}
            showMarketingFilters={showMarketingFilters}
        />
    }>
        <DashboardGrid>
            {children}
        </DashboardGrid>
    </WideSecureLayout>;
}
